import React from 'react'
import InputForm from '../components/InputForm'

const MealPlan = () => {
  return (
    <React.Fragment>
      <InputForm />
    </React.Fragment>
  )
}

export default MealPlan
